jQuery(document).ready(function($){
    $(".faq-slides").slick({
        infinite: false,
        slidesToShow: 4,
        swipeToSlide: true,
        centerMode: false,
        dots:true,
        arrows : true,
        responsive: [
            {
              breakpoint: 1600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
              }
            },
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                adaptiveHeight: true
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                adaptiveHeight: true

              }
            }
          ]
    });
    $(".services-slides").slick({
        infinite: false,
        slidesToShow: 2,
        swipeToSlide: true,
        centerMode: false,
        dots:true,
        arrows : true,
        responsive: [
            {
              breakpoint: 1199,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1,
                arrows: false
              }
            },

          ]
    });
});